import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class AccessInterceptor implements HttpInterceptor {
	constructor(private router: Router, private zone: NgZone) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			catchError((error: HttpErrorResponse) => {
				return this.handleErrorStatus(error);
			})
		);
	}

	private handleErrorStatus(error: HttpErrorResponse): Observable<never> {
		if (error.status === HttpStatusCode.Unauthorized || error.status === HttpStatusCode.Forbidden) {
			this.zone.run(() => {
				this.router.navigate(['/access-denied']);
			});
		}
		return throwError(() => error);
	}
}
